import React from 'react';
import { getTestIds } from '../../utils/TestIds';
export const GetPageTID = (parentTestId)=>getTestIds(parentTestId);
